module.exports = __webpack_public_path__ + "img/共产党员网.6991518e.jpg";